import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: resolve => {
        require(['@/components/success.vue'], resolve)
      },
    },
    {
      path: '/register/:service',
      name: 'registerBeta',
      component: resolve => {
        require(['@/components/user/registerBeta.vue'], resolve)
      },
    },
    {
      path: '/memberpage/:service',
      name: 'memberpage',
      component: resolve => {
        require(['@/components/user/bottomNav.vue'], resolve)
      },
    }
  ]
})


export default router;